"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _field = require("@design/ui/field");
var _textarea = require("@design/ui/textarea");
var _ContentContainer = _interopRequireDefault(require("../components/layout/ContentContainer"));
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _materialSymbols = require("@design/icons/material-symbols");
var _PageContext = require("../context/PageContext");
var _TagInput = require("../components/common/TagInput");
var _ResourceSharePopover = require("../components/share/ResourceSharePopover");
var _resourceShareCopy = require("@common/components/share/resource-share-dialog/resource-share-copy");
var _AuthContext = require("../context/AuthContext");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _WordDocumentContext = require("../context/WordDocumentContext");
var _toast = require("../utils/toast");
var _document = require("../utils/document");
var _webApi = require("../utils/web-api");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var ClausePage = function ClausePage() {
  var _navClause$tags, _navClause$contentTex, _navClause$access$isO, _navClause$access, _navClause$access$can, _navClause$access2, _navClause$sharing;
  var _usePage = (0, _PageContext.usePage)(),
    pageParams = _usePage.pageParams,
    showPage = _usePage.showPage;
  var navClause = pageParams.clause;
  var authHeader = (0, _AuthContext.useAuthHeader)();
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    user = _useAuthInfo.user;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    isWriteRestricted = _useWordDocument.isWriteRestricted;
  var _useState = (0, _react.useState)((_navClause$tags = navClause === null || navClause === void 0 ? void 0 : navClause.tags) !== null && _navClause$tags !== void 0 ? _navClause$tags : []),
    _useState2 = _slicedToArray(_useState, 2),
    tags = _useState2[0],
    setTags = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    availableTags = _useState4[0],
    setAvailableTags = _useState4[1];
  var _useState5 = (0, _react.useState)((_navClause$contentTex = navClause === null || navClause === void 0 ? void 0 : navClause.contentText) !== null && _navClause$contentTex !== void 0 ? _navClause$contentTex : ""),
    _useState6 = _slicedToArray(_useState5, 2),
    content = _useState6[0],
    setContent = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSaving = _useState8[0],
    setIsSaving = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isInserting = _useState0[0],
    setIsInserting = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showDeleteDialog = _useState10[0],
    setShowDeleteDialog = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isShareOpen = _useState12[0],
    setIsShareOpen = _useState12[1];
  var shareButtonRef = (0, _react.useRef)(null);
  var fieldId = (0, _react.useId)();

  // Suggest tags from the clauses this user can access (mirrors prompt tag UX).
  (0, _react.useEffect)(function () {
    if (!authHeader) return;
    (0, _webApi.fetchUserClauseTags)(authHeader).then(setAvailableTags).catch(function (err) {
      return console.error("Failed to load clause tags:", err);
    });
  }, [authHeader]);
  if (!navClause) {
    return null;
  }
  var isOwner = (_navClause$access$isO = (_navClause$access = navClause.access) === null || _navClause$access === void 0 ? void 0 : _navClause$access.isOwner) !== null && _navClause$access$isO !== void 0 ? _navClause$access$isO : navClause.propelAuthUserID === (user === null || user === void 0 ? void 0 : user.userId);
  var canManageShares = (_navClause$access$can = (_navClause$access2 = navClause.access) === null || _navClause$access2 === void 0 ? void 0 : _navClause$access2.canManageShares) !== null && _navClause$access$can !== void 0 ? _navClause$access$can : false;
  var goBack = function goBack() {
    return showPage(_PageContext.PAGES.libraryPage, {
      activeTab: "clauses"
    });
  };
  var handleInsert = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var ok;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!isWriteRestricted) {
              _context.n = 1;
              break;
            }
            (0, _toast.toastError)("This document is read-only");
            return _context.a(2);
          case 1:
            setIsInserting(true);
            _context.p = 2;
            _context.n = 3;
            return (0, _document.insertTextAtCursor)(content);
          case 3:
            ok = _context.v;
            if (ok) {
              (0, _toast.toastSuccess)("Clause inserted");
            } else {
              (0, _toast.toastError)("Failed to insert clause");
            }
          case 4:
            _context.p = 4;
            setIsInserting(false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[2,, 4, 5]]);
    }));
    return function handleInsert() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSave = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (isOwner) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            if (authHeader) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2);
          case 2:
            if (content.trim()) {
              _context2.n = 3;
              break;
            }
            (0, _toast.toastError)("Clause content cannot be empty");
            return _context2.a(2);
          case 3:
            setIsSaving(true);
            _context2.p = 4;
            _context2.n = 5;
            return (0, _webApi.updateUserClause)(authHeader, navClause.id, _objectSpread({
              tags: tags
            }, content !== navClause.contentText ? {
              contentText: content
            } : {}));
          case 5:
            (0, _toast.toastSuccess)("Clause updated");
            goBack();
            _context2.n = 7;
            break;
          case 6:
            _context2.p = 6;
            _t = _context2.v;
            console.error("Failed to update clause:", _t);
            sendError(_t, {
              component: "ClausePage",
              action: "update_clause"
            });
            (0, _toast.toastError)("Failed to update clause");
          case 7:
            _context2.p = 7;
            setIsSaving(false);
            return _context2.f(7);
          case 8:
            return _context2.a(2);
        }
      }, _callee2, null, [[4, 6, 7, 8]]);
    }));
    return function handleSave() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleDelete = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            setShowDeleteDialog(false);
            if (authHeader) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            _context3.p = 1;
            _context3.n = 2;
            return (0, _webApi.deleteUserClause)(authHeader, navClause.id);
          case 2:
            (0, _toast.toastSuccess)("Clause deleted");
            goBack();
            _context3.n = 4;
            break;
          case 3:
            _context3.p = 3;
            _t2 = _context3.v;
            console.error("Failed to delete clause:", _t2);
            sendError(_t2, {
              component: "ClausePage",
              action: "delete_clause"
            });
            (0, _toast.toastError)("Failed to delete clause");
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function handleDelete() {
      return _ref3.apply(this, arguments);
    };
  }();
  var heading = isOwner ? "Edit Clause" : "View Clause";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ContentContainer.default, {
    className: "flex flex-col items-start p-0 bg-white h-full",
    "data-sentry-element": "ContentContainer",
    "data-sentry-component": "ClausePage",
    "data-sentry-source-file": "ClausePage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-1 flex flex-col items-start px-3 py-4 gap-5 w-full overflow-y-auto",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-3 w-full",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          className: "flex items-center justify-center cursor-pointer bg-transparent border-none p-0",
          onClick: goBack,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ArrowBackIcon, {
            width: 20,
            height: 20,
            className: "text-[#212528]",
            "data-sentry-element": "ArrowBackIcon",
            "data-sentry-source-file": "ClausePage.tsx"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "flex-1 text-[16px] font-semibold text-[#212528]",
          children: heading
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex items-center gap-1",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "flex items-center justify-center w-8 h-8 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none disabled:opacity-40 disabled:cursor-not-allowed",
            title: isWriteRestricted ? "Document is read-only" : "Insert at cursor",
            onClick: handleInsert,
            disabled: isInserting || isWriteRestricted,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {
              width: 18,
              height: 18,
              className: "text-[#6B7280]",
              "data-sentry-element": "DownloadIcon",
              "data-sentry-source-file": "ClausePage.tsx"
            })
          }), canManageShares && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            ref: shareButtonRef,
            className: "flex items-center justify-center w-8 h-8 rounded hover:bg-background-primary-canvas cursor-pointer bg-transparent border-none",
            title: "Share",
            onClick: function onClick() {
              return setIsShareOpen(true);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ShareIcon, {
              width: 18,
              height: 18,
              className: (_navClause$sharing = navClause.sharing) !== null && _navClause$sharing !== void 0 && _navClause$sharing.hasAnyShares ? "text-primary" : "text-[#6B7280]"
            })
          }), isOwner && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            className: "flex items-center justify-center w-8 h-8 rounded hover:bg-[#FEE4E2] cursor-pointer bg-transparent border-none",
            title: "Delete",
            onClick: function onClick() {
              return setShowDeleteDialog(true);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DeleteIcon, {
              width: 18,
              height: 18,
              className: "text-[#6B7280]"
            })
          })]
        })]
      }), !isOwner && navClause.ownerName && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "text-[13px] text-[#686766]",
        children: ["Shared by ", navClause.ownerName]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "ClausePage.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-content"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "ClausePage.tsx",
          children: "Clause"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
          id: "".concat(fieldId, "-content"),
          rows: 6,
          value: content,
          onChange: function onChange(e) {
            return setContent(e.target.value);
          },
          placeholder: "Type in your clause",
          disabled: !isOwner,
          "data-sentry-element": "Textarea",
          "data-sentry-source-file": "ClausePage.tsx"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_field.Field, {
        "data-sentry-element": "Field",
        "data-sentry-source-file": "ClausePage.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
          htmlFor: "".concat(fieldId, "-tags"),
          "data-sentry-element": "FieldLabel",
          "data-sentry-source-file": "ClausePage.tsx",
          children: "Tags"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TagInput.TagInput, {
          id: "".concat(fieldId, "-tags"),
          selectedTags: tags,
          onTagsChange: setTags,
          disabled: !isOwner,
          availableTags: availableTags,
          "data-sentry-element": "TagInput",
          "data-sentry-source-file": "ClausePage.tsx"
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-shrink-0 flex items-center justify-end gap-2 w-full px-3 py-2.5 bg-white border-t border-[#E4E7EC]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: goBack,
        className: "flex justify-center items-center h-[36px] px-[11.25px] py-[6.75px] border border-[#D4D3D0] rounded text-[14px] font-medium text-[#3D3D3D] bg-transparent cursor-pointer hover:bg-[#F8F6F3]",
        children: isOwner ? "Cancel" : "Back"
      }), isOwner && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        onClick: handleSave,
        disabled: isSaving,
        className: "flex justify-center items-center h-[36px] px-[11.25px] py-[6.75px] gap-[2.25px] rounded text-[14px] font-medium text-white border-none cursor-pointer ".concat(isSaving ? "bg-[#B0AFAD] cursor-not-allowed" : "bg-primary hover:bg-background-primary-hover"),
        children: isSaving ? "Saving..." : "Save"
      })]
    }), showDeleteDialog && /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
      tone: "destructive",
      title: "Confirm delete",
      message: "Are you sure you want to delete this clause?",
      confirmLabel: "Delete",
      onConfirm: handleDelete,
      onCancel: function onCancel() {
        return setShowDeleteDialog(false);
      }
    }), isShareOpen && shareButtonRef.current && canManageShares && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResourceSharePopover.ResourceSharePopover, {
      resourceKind: "clause",
      resourceId: navClause.id,
      resourceName: (0, _resourceShareCopy.clauseShareTitle)(navClause.contentText),
      anchorEl: shareButtonRef.current,
      access: navClause.access,
      onClose: function onClose() {
        return setIsShareOpen(false);
      }
    })]
  });
};
var _default = exports.default = ClausePage;